import type {
  SasfinWealthOnlineBlModelsProposalClientView,
  SasfinWealthOnlineBlModelsProposalProposalDocReview,
  SasfinWealthOnlineBlModelsProposalProposalManagementView,
} from '../../generated/auth/models';

export type ProposalClientView = SasfinWealthOnlineBlModelsProposalClientView;
export type ProposalManagementView = SasfinWealthOnlineBlModelsProposalProposalManagementView;
export type ProposalDocReview = SasfinWealthOnlineBlModelsProposalProposalDocReview;

export interface ProposalFilters {
  FirstName?: string;
  LastName?: string;
  CrmNumber?: string;
  IdentityOrPassport?: string;
  Search?: string;
  SortBy?: string;
  SortDescending?: boolean;
  Page?: number;
  PageSize?: number;
}

export interface ProposalLoadParams extends ProposalFilters {}

export const defaultProposalFilters: ProposalFilters = {
  FirstName: '',
  LastName: '',
  CrmNumber: '',
  IdentityOrPassport: '',
  Search: '',
  SortBy: 'CreatedAt',
  SortDescending: true,
  Page: 1,
  PageSize: 10,
};
